import _ from 'lodash'

export const cityData = [
  {
    'value': '510000',
    'label': '四川省',
    'children': [
      {
        'value': '510100',
        'label': '成都市'
      },
      {
        'value': '510300',
        'label': '自贡市'
      },
      {
        'value': '510400',
        'label': '攀枝花市'
      },
      {
        'value': '510500',
        'label': '泸州市'
      },
      {
        'value': '510600',
        'label': '德阳市'
      },
      {
        'value': '510700',
        'label': '绵阳市'
      },
      {
        'value': '510800',
        'label': '广元市'
      },
      {
        'value': '510900',
        'label': '遂宁市'
      },
      {
        'value': '511000',
        'label': '内江市'
      },
      {
        'value': '511100',
        'label': '乐山市'
      },
      {
        'value': '511300',
        'label': '南充市'
      },
      {
        'value': '511400',
        'label': '眉山市'
      },
      {
        'value': '511500',
        'label': '宜宾市'
      },
      {
        'value': '511600',
        'label': '广安市'
      },
      {
        'value': '511700',
        'label': '达州市'
      },
      {
        'value': '511800',
        'label': '雅安市'
      },
      {
        'value': '511900',
        'label': '巴中市'
      },
      {
        'value': '512000',
        'label': '资阳市'
      },
      {
        'value': '513200',
        'label': '阿坝藏族羌族自治州'
      },
      {
        'value': '513300',
        'label': '甘孜藏族自治州'
      },
      {
        'value': '513400',
        'label': '凉山彝族自治州'
      }
    ]
  }
]

export const areaData = [
  {
    'value': '510000',
    'label': '四川省',
    'disabled': true,
    'children': [
      {
        'value': '510100',
        'label': '成都市',
        'children': [
          {
            'value': '510104',
            'label': '锦江区'
          },
          {
            'value': '510105',
            'label': '青羊区'
          },
          {
            'value': '510106',
            'label': '金牛区'
          },
          {
            'value': '510107',
            'label': '武侯区'
          },
          {
            'value': '510108',
            'label': '成华区'
          },
          {
            'value': '510112',
            'label': '龙泉驿区'
          },
          {
            'value': '510113',
            'label': '青白江区'
          },
          {
            'value': '510114',
            'label': '新都区'
          },
          {
            'value': '510115',
            'label': '温江区'
          },
          {
            'value': '510121',
            'label': '金堂县'
          },
          {
            'value': '510122',
            'label': '双流县'
          },
          {
            'value': '510124',
            'label': '郫都区'
          },
          {
            'value': '510125',
            'label': '高新区'
          },
          {
            'value': '510126',
            'label': '天府新区'
          },
          {
            'value': '510129',
            'label': '大邑县'
          },
          {
            'value': '510131',
            'label': '蒲江县'
          },
          {
            'value': '510132',
            'label': '新津县'
          },
          {
            'value': '510181',
            'label': '都江堰市'
          },
          {
            'value': '510182',
            'label': '彭州市'
          },
          {
            'value': '510183',
            'label': '邛崃市'
          },
          {
            'value': '510184',
            'label': '崇州市'
          }
        ]
      },
      {
        'value': '510300',
        'label': '自贡市',
        'children': [
          {
            'value': '510302',
            'label': '自流井区'
          },
          {
            'value': '510303',
            'label': '贡井区'
          },
          {
            'value': '510304',
            'label': '大安区'
          },
          {
            'value': '510311',
            'label': '沿滩区'
          },
          {
            'value': '510321',
            'label': '荣　县'
          },
          {
            'value': '510322',
            'label': '富顺县'
          }
        ]
      },
      {
        'value': '510400',
        'label': '攀枝花市',
        'children': [
          {
            'value': '510402',
            'label': '东　区'
          },
          {
            'value': '510403',
            'label': '西　区'
          },
          {
            'value': '510411',
            'label': '仁和区'
          },
          {
            'value': '510421',
            'label': '米易县'
          },
          {
            'value': '510422',
            'label': '盐边县'
          }
        ]
      },
      {
        'value': '510500',
        'label': '泸州市',
        'children': [
          {
            'value': '510502',
            'label': '江阳区'
          },
          {
            'value': '510503',
            'label': '纳溪区'
          },
          {
            'value': '510504',
            'label': '龙马潭区'
          },
          {
            'value': '510521',
            'label': '泸　县'
          },
          {
            'value': '510522',
            'label': '合江县'
          },
          {
            'value': '510524',
            'label': '叙永县'
          },
          {
            'value': '510525',
            'label': '古蔺县'
          }
        ]
      },
      {
        'value': '510600',
        'label': '德阳市',
        'children': [
          {
            'value': '510603',
            'label': '旌阳区'
          },
          {
            'value': '510623',
            'label': '中江县'
          },
          {
            'value': '510626',
            'label': '罗江县'
          },
          {
            'value': '510681',
            'label': '广汉市'
          },
          {
            'value': '510682',
            'label': '什邡市'
          },
          {
            'value': '510683',
            'label': '绵竹市'
          }
        ]
      },
      {
        'value': '510700',
        'label': '绵阳市',
        'children': [
          {
            'value': '510703',
            'label': '涪城区'
          },
          {
            'value': '510704',
            'label': '游仙区'
          },
          {
            'value': '510722',
            'label': '三台县'
          },
          {
            'value': '510723',
            'label': '盐亭县'
          },
          {
            'value': '510724',
            'label': '安　县'
          },
          {
            'value': '510725',
            'label': '梓潼县'
          },
          {
            'value': '510726',
            'label': '北川羌族自治县'
          },
          {
            'value': '510727',
            'label': '平武县'
          },
          {
            'value': '510781',
            'label': '江油市'
          }
        ]
      },
      {
        'value': '510800',
        'label': '广元市',
        'children': [
          {
            'value': '510802',
            'label': '利州区'
          },
          {
            'value': '510811',
            'label': '昭化区'
          },
          {
            'value': '510812',
            'label': '朝天区'
          },
          {
            'value': '510821',
            'label': '旺苍县'
          },
          {
            'value': '510822',
            'label': '青川县'
          },
          {
            'value': '510823',
            'label': '剑阁县'
          },
          {
            'value': '510824',
            'label': '苍溪县'
          }
        ]
      },
      {
        'value': '510900',
        'label': '遂宁市',
        'children': [
          {
            'value': '510903',
            'label': '船山区'
          },
          {
            'value': '510904',
            'label': '安居区'
          },
          {
            'value': '510921',
            'label': '蓬溪县'
          },
          {
            'value': '510922',
            'label': '射洪县'
          },
          {
            'value': '510923',
            'label': '大英县'
          }
        ]
      },
      {
        'value': '511000',
        'label': '内江市',
        'children': [
          {
            'value': '511002',
            'label': '市中区'
          },
          {
            'value': '511011',
            'label': '东兴区'
          },
          {
            'value': '511024',
            'label': '威远县'
          },
          {
            'value': '511025',
            'label': '资中县'
          },
          {
            'value': '511028',
            'label': '隆昌县'
          }
        ]
      },
      {
        'value': '511100',
        'label': '乐山市',
        'children': [
          {
            'value': '511102',
            'label': '市中区'
          },
          {
            'value': '511111',
            'label': '沙湾区'
          },
          {
            'value': '511112',
            'label': '五通桥区'
          },
          {
            'value': '511113',
            'label': '金口河区'
          },
          {
            'value': '511123',
            'label': '犍为县'
          },
          {
            'value': '511124',
            'label': '井研县'
          },
          {
            'value': '511126',
            'label': '夹江县'
          },
          {
            'value': '511129',
            'label': '沐川县'
          },
          {
            'value': '511132',
            'label': '峨边彝族自治县'
          },
          {
            'value': '511133',
            'label': '马边彝族自治县'
          },
          {
            'value': '511181',
            'label': '峨眉山市'
          }
        ]
      },
      {
        'value': '511300',
        'label': '南充市',
        'children': [
          {
            'value': '511302',
            'label': '顺庆区'
          },
          {
            'value': '511303',
            'label': '高坪区'
          },
          {
            'value': '511304',
            'label': '嘉陵区'
          },
          {
            'value': '511321',
            'label': '南部县'
          },
          {
            'value': '511322',
            'label': '营山县'
          },
          {
            'value': '511323',
            'label': '蓬安县'
          },
          {
            'value': '511324',
            'label': '仪陇县'
          },
          {
            'value': '511325',
            'label': '西充县'
          },
          {
            'value': '511381',
            'label': '阆中市'
          }
        ]
      },
      {
        'value': '511400',
        'label': '眉山市',
        'children': [
          {
            'value': '511402',
            'label': '东坡区'
          },
          {
            'value': '511403',
            'label': '彭山区'
          },
          {
            'value': '511421',
            'label': '仁寿县'
          },
          {
            'value': '511423',
            'label': '洪雅县'
          },
          {
            'value': '511424',
            'label': '丹棱县'
          },
          {
            'value': '511425',
            'label': '青神县'
          }
        ]
      },
      {
        'value': '511500',
        'label': '宜宾市',
        'children': [
          {
            'value': '511502',
            'label': '翠屏区'
          },
          {
            'value': '511503',
            'label': '南溪区'
          },
          {
            'value': '511521',
            'label': '宜宾县'
          },
          {
            'value': '511523',
            'label': '江安县'
          },
          {
            'value': '511524',
            'label': '长宁县'
          },
          {
            'value': '511525',
            'label': '高　县'
          },
          {
            'value': '511526',
            'label': '珙　县'
          },
          {
            'value': '511527',
            'label': '筠连县'
          },
          {
            'value': '511528',
            'label': '兴文县'
          },
          {
            'value': '511529',
            'label': '屏山县'
          }
        ]
      },
      {
        'value': '511600',
        'label': '广安市',
        'children': [
          {
            'value': '511602',
            'label': '广安区'
          },
          {
            'value': '511603',
            'label': '前锋区'
          },
          {
            'value': '511621',
            'label': '岳池县'
          },
          {
            'value': '511622',
            'label': '武胜县'
          },
          {
            'value': '511623',
            'label': '邻水县'
          },
          {
            'value': '511681',
            'label': '华蓥市'
          }
        ]
      },
      {
        'value': '511700',
        'label': '达州市',
        'children': [
          {
            'value': '511702',
            'label': '通川区'
          },
          {
            'value': '511703',
            'label': '达川区'
          },
          {
            'value': '511722',
            'label': '宣汉县'
          },
          {
            'value': '511723',
            'label': '开江县'
          },
          {
            'value': '511724',
            'label': '大竹县'
          },
          {
            'value': '511725',
            'label': '渠　县'
          },
          {
            'value': '511781',
            'label': '万源市'
          }
        ]
      },
      {
        'value': '511800',
        'label': '雅安市',
        'children': [
          {
            'value': '511802',
            'label': '雨城区'
          },
          {
            'value': '511803',
            'label': '名山区'
          },
          {
            'value': '511822',
            'label': '荥经县'
          },
          {
            'value': '511823',
            'label': '汉源县'
          },
          {
            'value': '511824',
            'label': '石棉县'
          },
          {
            'value': '511825',
            'label': '天全县'
          },
          {
            'value': '511826',
            'label': '芦山县'
          },
          {
            'value': '511827',
            'label': '宝兴县'
          }
        ]
      },
      {
        'value': '511900',
        'label': '巴中市',
        'children': [
          {
            'value': '511902',
            'label': '巴州区'
          },
          {
            'value': '511903',
            'label': '恩阳区'
          },
          {
            'value': '511921',
            'label': '通江县'
          },
          {
            'value': '511922',
            'label': '南江县'
          },
          {
            'value': '511923',
            'label': '平昌县'
          }
        ]
      },
      {
        'value': '512000',
        'label': '资阳市',
        'children': [
          {
            'value': '512002',
            'label': '雁江区'
          },
          {
            'value': '512021',
            'label': '安岳县'
          },
          {
            'value': '512022',
            'label': '乐至县'
          },
          {
            'value': '512081',
            'label': '简阳市'
          }
        ]
      },
      {
        'value': '513200',
        'label': '阿坝藏族羌族自治州',
        'children': [
          {
            'value': '513221',
            'label': '汶川县'
          },
          {
            'value': '513222',
            'label': '理　县'
          },
          {
            'value': '513223',
            'label': '茂　县'
          },
          {
            'value': '513224',
            'label': '松潘县'
          },
          {
            'value': '513225',
            'label': '九寨沟县'
          },
          {
            'value': '513226',
            'label': '金川县'
          },
          {
            'value': '513227',
            'label': '小金县'
          },
          {
            'value': '513228',
            'label': '黑水县'
          },
          {
            'value': '513229',
            'label': '马尔康县'
          },
          {
            'value': '513230',
            'label': '壤塘县'
          },
          {
            'value': '513231',
            'label': '阿坝县'
          },
          {
            'value': '513232',
            'label': '若尔盖县'
          },
          {
            'value': '513233',
            'label': '红原县'
          }
        ]
      },
      {
        'value': '513300',
        'label': '甘孜藏族自治州',
        'children': [
          {
            'value': '513321',
            'label': '康定县'
          },
          {
            'value': '513322',
            'label': '泸定县'
          },
          {
            'value': '513323',
            'label': '丹巴县'
          },
          {
            'value': '513324',
            'label': '九龙县'
          },
          {
            'value': '513325',
            'label': '雅江县'
          },
          {
            'value': '513326',
            'label': '道孚县'
          },
          {
            'value': '513327',
            'label': '炉霍县'
          },
          {
            'value': '513328',
            'label': '甘孜县'
          },
          {
            'value': '513329',
            'label': '新龙县'
          },
          {
            'value': '513330',
            'label': '德格县'
          },
          {
            'value': '513331',
            'label': '白玉县'
          },
          {
            'value': '513332',
            'label': '石渠县'
          },
          {
            'value': '513333',
            'label': '色达县'
          },
          {
            'value': '513334',
            'label': '理塘县'
          },
          {
            'value': '513335',
            'label': '巴塘县'
          },
          {
            'value': '513336',
            'label': '乡城县'
          },
          {
            'value': '513337',
            'label': '稻城县'
          },
          {
            'value': '513338',
            'label': '得荣县'
          }
        ]
      },
      {
        'value': '513400',
        'label': '凉山彝族自治州',
        'children': [
          {
            'value': '513401',
            'label': '西昌市'
          },
          {
            'value': '513422',
            'label': '木里藏族自治县'
          },
          {
            'value': '513423',
            'label': '盐源县'
          },
          {
            'value': '513424',
            'label': '德昌县'
          },
          {
            'value': '513425',
            'label': '会理县'
          },
          {
            'value': '513426',
            'label': '会东县'
          },
          {
            'value': '513427',
            'label': '宁南县'
          },
          {
            'value': '513428',
            'label': '普格县'
          },
          {
            'value': '513429',
            'label': '布拖县'
          },
          {
            'value': '513430',
            'label': '金阳县'
          },
          {
            'value': '513431',
            'label': '昭觉县'
          },
          {
            'value': '513432',
            'label': '喜德县'
          },
          {
            'value': '513433',
            'label': '冕宁县'
          },
          {
            'value': '513434',
            'label': '越西县'
          },
          {
            'value': '513435',
            'label': '甘洛县'
          },
          {
            'value': '513436',
            'label': '美姑县'
          },
          {
            'value': '513437',
            'label': '雷波县'
          }
        ]
      }
    ]
  }
]

// 获取省市名称
export const getCityTxt = (v) => {
  const p = _.find(areaData, { value: v[0] })
  if (p) {
    const c = _.find(p.children, { value: v[1] })
    return `${p.label} ${c.label}`
  } else {
    return '未查到省级地区编码'
  }
}

// 获取全名称（省、市、区）
export const getAreaTxt = (v) => {
  if (v.length < 2) return '传入地区数组有误'
  const p = _.find(areaData, { value: v[0] })
  if (p) {
    const c = _.find(p.children, { value: v[1] })
    if (c && !_.isEmpty(v[2])) {
      const a = _.find(c.children, { value: v[2] })
      return `${p.label} ${c.label} ${a.label}`
    } else {
      return `${p.label} ${c.label}`
    }
  } else {
    return '未查到相应地区编码'
  }
}

export const getAreaTxtComma = (v) => {
  let area = getAreaTxt(v)
  return area.replace(/\s/g, ',')
}

// 获取子一级地区信息
export const getSubArea = vuexLoc => {
  const p = _.cloneDeep(_.find(areaData, { value: vuexLoc[0] }))
  if (p) {
    const c = _.find(p.children, { value: vuexLoc[1] })
    c.children.forEach(i => {
      i.id = i.value
      i.name = i.label
    })
    return _.cloneDeep(c)
  } else {
    return '未查到相应地区编码'
  }
}
